export enum THEME {
  LIGHT = "light",
  DARK = "dark",
  SYSTEM = "auto",
}

export enum CALENDAR_APPLICATION {
  NONE = "none",
  CALENDLY = "calendly",
  GAIL = "cal_dot_com",
}

export enum CAMPAIGN_VERSION {
  V1 = "v1",
  V2 = "v2",
}

export enum GPT_VERSION {
  V1 = "v1",
  V2 = "v2",
}

export enum SCRIPT_API_VERSION {
  V1 = "v1",
  V2 = "v2",
}

export enum PRODUCT_NAME {
  GailAgent = "GailAgent",
  GailGPT = "GailGPT",
}
